var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsDoughnutLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons_Doughnut_Line",
    "data-name": "icons/Doughnut/Line",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.865,
    height: 13.333,
    viewBox: "0 0 11.865 13.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M5.933,13.333C2.661,13.333,0,10.343,0,6.667S2.661,0,5.933,0s5.933,2.991,5.933,6.667S9.2,13.333,5.933,13.333ZM4.727,8.964l-1.7,1.916a4.341,4.341,0,0,0,5.821,0l-1.7-1.916a2.151,2.151,0,0,1-2.411,0Zm1.8-7.589v2.71a2.629,2.629,0,0,1,1.78,2.582,2.921,2.921,0,0,1-.329,1.355l1.7,1.916a5.714,5.714,0,0,0,1-3.271A5.165,5.165,0,0,0,6.526,1.375Zm-1.186,0A5.165,5.165,0,0,0,1.186,6.667a5.713,5.713,0,0,0,1,3.271l1.7-1.916A2.922,2.922,0,0,1,3.56,6.667a2.629,2.629,0,0,1,1.78-2.582Zm.593,3.959A1.268,1.268,0,0,0,4.746,6.667,1.268,1.268,0,0,0,5.933,8,1.268,1.268,0,0,0,7.119,6.667,1.268,1.268,0,0,0,5.933,5.333Z",
    fill: "#fcfcfd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDoughnutLine);
export default __webpack_public_path__ + "static/media/iconsDoughnutLine.3abd8c4789aa84dca6a2583d56cf867e.svg";
export { ForwardRef as ReactComponent };